import { SET_TITLE, SET_REPORT_TITLE, SET_PO_TITLE, SET_ECOM_TITLE } from './constants';

export const setTitle = title => ({
  type: SET_TITLE,
  payload: title,
});

export const setReportTitle = title => ({
  type: SET_REPORT_TITLE,
  payload: title,
});

export const setPoTitle = title => ({
  type: SET_PO_TITLE,
  payload: title,
});

export const setEcomTitle = title => ({
  type: SET_ECOM_TITLE,
  payload: title,
});
